import * as React from "react";

const SvgComponent = (props) => (
  <svg
    width={25}
    height={22}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m6.902 14.105 13.044-9.912-9.925 11.84-.007.01a.991.991 0 0 0-.053.08l-.015.027a.644.644 0 0 0-.013.029l-.013.03c0 .004-.002.008-.004.011l-1.148 3.382-1.866-5.497ZM24.297.733a.345.345 0 0 0 .006-.026l.005-.024.004-.028a.572.572 0 0 0 .004-.102L24.314.53a.608.608 0 0 0-.007-.05l-.005-.025-.006-.026-.008-.024a.493.493 0 0 0-.008-.025L24.27.352l-.009-.02a.654.654 0 0 0-.024-.045.578.578 0 0 0-.03-.045L24.2.232l-.024-.03-.016-.017-.02-.02-.02-.02-.018-.015a.76.76 0 0 0-.068-.047l-.014-.008-.004-.003a.534.534 0 0 0-.027-.013l-.02-.01-.024-.01-.026-.01-.02-.005-.03-.008-.02-.005a.485.485 0 0 0-.03-.005l-.022-.003-.028-.002a.481.481 0 0 0-.076 0l-.025.003c-.009 0-.017.002-.026.003a.537.537 0 0 0-.078.018l-.02.007a.572.572 0 0 0-.032.012l-.012.005L.349 10.204a.583.583 0 0 0-.051 1.042l5.436 3.048 2.479 7.3a.576.576 0 0 0 .17.26c.11.098.248.146.386.146h.008a.58.58 0 0 0 .42-.187l3.362-3.568 4.257 2.382a.583.583 0 0 0 .838-.322L24.286.77l.004-.012a.605.605 0 0 0 .007-.025Z"
      fill="#0009"
    />
  </svg>
);

export default SvgComponent;
